import { useCallback } from 'react';

import { CONTENT_TYPES } from '@hivebrite/design-system/ContentList';

import { useNavigateToNewsDetail } from 'hb-react/frontoffice/apps/NewsIndex/hooks/useNavigateToNewsDetail';
import type {
  AvailableContentTypes,
  RecommendedContents,
} from 'hb-react/shared/components/ContentRecommendation/types';

export const useNavigateToContentItem = () => {
  const { onClick: navigateToNews } = useNavigateToNewsDetail();

  return useCallback(
    (contentItem: RecommendedContents[AvailableContentTypes]) => {
      switch (contentItem.type) {
        case CONTENT_TYPES.NEWS:
          return navigateToNews(contentItem.uuid ?? Number(contentItem.id));
        default:
          return null;
      }
    },
    [navigateToNews],
  );
};
